import { Link } from 'react-router-dom';
import CookieBanner from './CookieBanner';

const Footer = () => {
  return (
    <footer className="bg-graphite text-white mt-24 mx-4 md:mx-6 rounded-t-[32px] relative overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 text-[80px] md:text-[120px] font-bold text-gray-dark/10 text-center leading-none pb-4 select-none overflow-hidden">
        JUSTCLEAN
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-primary rounded-lg flex-shrink-0">
                <i className="ri-sparkling-2-fill text-white text-2xl"></i>
              </div>
              <span className="text-2xl font-bold text-white">JUSTCLEAN</span>
            </div>
            <p className="text-silver-light text-sm leading-relaxed">
              Profesionales en vaciado de pisos, locales y limpieza extrema en Castelldefels y Baix Llobregat Sud
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Navegación</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-silver-light hover:text-white transition-colors cursor-pointer">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-silver-light hover:text-white transition-colors cursor-pointer">
                  Empresa
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-silver-light hover:text-white transition-colors cursor-pointer">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-silver-light hover:text-white transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-silver-light hover:text-white transition-colors cursor-pointer">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Síguenos</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-2 text-silver-light hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-primary"></i>
                  <span>Instagram</span>
                </a>
              </li>
              <li>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-2 text-silver-light hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-line text-primary"></i>
                  <span>Facebook</span>
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center space-x-2 text-silver-light hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-line text-primary"></i>
                  <span>LinkedIn</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Newsletter</h4>
            <p className="text-silver-light text-sm mb-4">
              Recibe nuestras ofertas y novedades
            </p>
            <div className="flex items-center bg-white/10 rounded-full overflow-hidden max-w-full">
              <input
                type="email"
                placeholder="Tu email"
                className="flex-1 bg-transparent px-4 py-2 text-sm text-white placeholder-silver-dark outline-none min-w-0"
              />
              <button className="w-10 h-10 flex items-center justify-center bg-white rounded-full m-1 cursor-pointer hover:bg-silver-light transition-colors flex-shrink-0">
                <i className="ri-arrow-right-line text-primary"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-dark/50">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6 text-sm text-silver-dark">
              <Link to="/aviso-legal" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Aviso Legal
              </Link>
              <Link to="/politica-privacidad" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Política de Privacidad
              </Link>
              <Link to="/politica-cookies" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Política de Cookies
              </Link>
            </div>
            <p className="text-sm text-silver-dark text-center md:text-right">
              © 2025 JUSTCLEAN Castelldefels. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>

      <CookieBanner />
    </footer>
  );
};

export default Footer;
